import React from 'react';
import TopBarChinese from '../components/TopBarChinese';
import FooterChinese from '../components/FooterChinese';
import "../App.css";

function CalendarChinese() {
  return (
    <div>
      <TopBarChinese />
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h1>日曆</h1>
        <p>此功能目前正在開發中。</p>
        <div style={{
          border: '1px solid #ccc',
          borderRadius: '8px',
          height: '400px',
          width: '80%',
          margin: '20px auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f9f9f9'
        }}>
          <p style={{ color: '#888' }}>稍後查看以獲取更多更新。</p>
        </div>
      </div>
      <FooterChinese />
    </div>
  );
}

export default CalendarChinese;